import React from 'react';
import TreeCategory from './treeCategory';
import { get } from 'lodash';
import { DndContext, closestCenter, useSensors, useSensor, PointerSensor } from '@dnd-kit/core';
import { SortableContext, useSortable, verticalListSortingStrategy } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';

export default function IndexTree({
  data,
  updateCategory,
  parentIndex,
  listOpen,
  openClose,
  getCategories,
}) {
  const sensors = useSensors(
    useSensor(PointerSensor, {
      activationConstraint: {
        delay: 200,
        tolerance: 5,
      },
    })
  );

  function SortableSubCategoryItem({ value: subCategory, index }) {
    const { attributes, listeners, setNodeRef, transform, transition } = useSortable({
      id: subCategory.id || index,
    });

    const style = {
      transform: CSS.Transform.toString(transform),
      transition,
      userSelect: 'none',
    };

    return (
      <div ref={setNodeRef} style={style} {...attributes} {...listeners}>
        <TreeCategory
          titleWidth={12}
          titleOffset={2}
          listOpen={listOpen}
          openClose={openClose}
          key={index}
          data={subCategory}
          getCategories={getCategories}
        />
      </div>
    );
  }

  function SortableSubCategory({ items, categoryIndex, categories }) {
    const handleDragEnd = (event) => {
      const { active, over } = event;
      if (active && over && active.id !== over.id) {
        const oldIndex = items.findIndex((item, index) => (item.id || index) === active.id);
        const newIndex = items.findIndex((item, index) => (item.id || index) === over.id);

        let list = [...get(categories, 'subcategories', [])];
        let temp = list[oldIndex];
        list.splice(oldIndex, 1);
        list.splice(newIndex, 0, temp);

        const newList = list.map((item, i) => {
          item.order_level = i;
          return item;
        });

        updateCategory(newList, parentIndex, categoryIndex);
      }
    };

    return (
      <DndContext sensors={sensors} collisionDetection={closestCenter} onDragEnd={handleDragEnd}>
        <SortableContext items={items.map((item, index) => ({ id: item.id || index }))} strategy={verticalListSortingStrategy}>
          {items.map((item, index) => (
            <SortableSubCategoryItem
              key={item.id || index}
              index={index}
              value={item}
            />
          ))}
        </SortableContext>
      </DndContext>
    );
  }

  function SortableCategoryItem({ value: categories, index, valIndex }) {
    const { attributes, listeners, setNodeRef, transform, transition } = useSortable({
      id: categories.id || index,
    });

    const style = {
      transform: CSS.Transform.toString(transform),
      transition,
      userSelect: 'none',
    };

    return (
      <div ref={setNodeRef} style={style} {...attributes} {...listeners}>
        <TreeCategory
          titleWidth={13}
          titleOffset={1}
          listOpen={listOpen}
          openClose={openClose}
          data={categories}
          key={index}
          getCategories={getCategories}>
          <div id="drag-content">
            <SortableSubCategory
              items={get(categories, 'subcategories', [])}
              categoryIndex={valIndex}
              categories={categories}
            />
          </div>
        </TreeCategory>
      </div>
    );
  }

  function SortableCategories({ items }) {
    const handleDragEnd = (event) => {
      const { active, over } = event;
      if (active && over && active.id !== over.id) {
        const oldIndex = items.findIndex((item, index) => (item.id || index) === active.id);
        const newIndex = items.findIndex((item, index) => (item.id || index) === over.id);

        let list = [...get(data, 'subcategories', [])];
        let temp = list[oldIndex];
        list.splice(oldIndex, 1);
        list.splice(newIndex, 0, temp);

        const newList = list.map((item, i) => {
          item.order_level = i;
          return item;
        });

        updateCategory(newList, parentIndex);
      }
    };

    return (
      <DndContext sensors={sensors} collisionDetection={closestCenter} onDragEnd={handleDragEnd}>
        <SortableContext items={items.map((item, index) => ({ id: item.id || index }))} strategy={verticalListSortingStrategy}>
          {items.map((item, index) => (
            <SortableCategoryItem
              key={item.id || index}
              index={index}
              valIndex={index}
              value={item}
            />
          ))}
        </SortableContext>
      </DndContext>
    );
  }

  return (
    <div>
      <TreeCategory
        data={data}
        titleWidth={14}
        listOpen={listOpen}
        openClose={openClose}
        getCategories={getCategories}>
        <div id="drag-content">
          <SortableCategories
            items={get(data, 'subcategories', [])}
          />
        </div>
      </TreeCategory>
    </div>
  );
}
